import React from "react";
// import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
// import CustomInput from "components/CustomSelect/CustomSelect.jsx";
import Add from "@material-ui/icons/AddBox";
import {appHelpers} from '../../_helpers';

import {
  Grid,
  FormControl,
  InputLabel
} from "@material-ui/core";

import { ProgressBar } from '../../utils/ProgressBar';
import {appConstants} from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  input:{
  marginTop:"0 !important"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width:"100%"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {        marginTop: "0px",        width: '100%'    }
});


 const SettingsPanel = ({
                            handleSubmit,
                            handleSelect,
                            airlineId,
                            airportCode,
                            airports,
                            classes,
                            progress,
                            error,
                            formError,
                            handleChange,
                            fullScreen,
                            airlinesData,
                            handleAdd,
                            isOpen,
                            handleClose,
                            user,
                            currentPsc,
                            disabled,
                            reactSelectChange,


 }) => {
    return (
        <div className={classes.root}>
            <ProgressBar isActive={progress}/>
          <Grid container spacing={24}>
              <Grid item xs={12}>
                  <div style={{float: 'left'}}>
                      <p className={classes.cardCategory} style={{margin: '0', fontSize: '14px'}}>
                          Current PSC Charge :
                      </p>
                      <h4 className={classes.cardTitle} style={{margin: '0'}}>
                          &#8358; {typeof(currentPsc) === "number" ? appHelpers.numberWithCommas(currentPsc) : currentPsc }
                      </h4>
                  </div>
                  <div style={{float: 'right'}}>
                      <Button
                          color="primary"
                          onClick = {handleAdd}
                          autoFocus
                      >
                          <Add/>  Add Minimum Re-order Level
                      </Button>
                  </div>
              </Grid>
          </Grid>
             <Dialog
                fullScreen={fullScreen}
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" style={{backgroundColor:"#66bb6a"}}>
                    <span style={{color:"white",textTransform:"uppercase"}}> Set Wallet Re-order Level</span>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={24}>
                    <Grid item md={12} sm={12}>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="age-simple">Select Airline</InputLabel>
                            <AutocompleteSelect
                            options={airlinesData.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                            selectedOption={airlineId}
                            handleSelectChange={(e, name) => reactSelectChange(e, name)}
                            // selectLabel={"Airlines"}
                            name={"airlineId"}
                            disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                            />
                            {/*<Select*/}
                                {/*value={airlineId}*/}
                                {/*disabled={user.AppRole === appConstants.ROLES.AIRLINE}*/}
                                {/*onChange={handleChange}*/}
                                {/*inputProps={{*/}
                                    {/*name: 'airlineId',*/}
                                    {/*id: 'airline',*/}
                                {/*}}*/}
                            {/*>*/}
                                {/*<MenuItem value="Placeholder">Select Airline</MenuItem>*/}
                                {/*{airlinesData.map((option, i) => (*/}
                                    {/*<MenuItem*/}
                                        {/*key={i}*/}
                                        {/*value={option.AirlineId}*/}
                                        {/*className={classes.select}*/}
                                    {/*>*/}
                                        {/*{option.Airline}*/}
                                    {/*</MenuItem>*/}
                                {/*))}*/}
                            {/*</Select>*/}
                        </FormControl>
                    </Grid>
                        <Grid item md={12} sm={12}>
                            <FormControl className={classes.formControl}>
                                <InputLabel shrink htmlFor="age-simple">Select Airport</InputLabel>
                                <AutocompleteSelect
                                    options={airports.map(option => ({ value: option.Code, label: option.Name }))}
                                    selectedOption={airportCode}
                                    handleSelectChange={(e, name) => reactSelectChange(e, name)}
                                    // selectLabel={"Airports"}
                                    disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                                    name={"airportCode2"}
                                />
                                {/*<Select*/}
                                    {/*disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}*/}
                                    {/*value={airportCode}*/}
                                    {/*onChange={(event)=>handleSelect(event)}*/}
                                    {/*formcontrolprops={{*/}
                                        {/*fullWidth: true*/}
                                    {/*}}*/}
                                    {/*inputProps={{*/}
                                        {/*name: 'airportCode2',*/}
                                        {/*id: 'airportCode2',*/}
                                    {/*}}*/}
                                {/*>*/}
                                    {/*<MenuItem value="Placeholder">Select Airport</MenuItem>*/}
                                    {/*{airports.map((option, i) => (*/}
                                        {/*<MenuItem*/}
                                            {/*key={i}*/}
                                            {/*value={option.Code}*/}
                                            {/*className={classes.select}*/}
                                        {/*>*/}
                                            {/*{option.Name}*/}
                                        {/*</MenuItem>*/}
                                    {/*))}*/}
                                {/*</Select>*/}
                            </FormControl>
                        </Grid>


                    {/*<Grid item md={12} sm={12}>*/}
                        {/*/!* <Paper className={classes.paper}> *!/*/}
                        {/*<CustomInput*/}
                            {/*className={classes.input}*/}
                            {/*required*/}
                            {/*labelText="oldToken"*/}
                            {/*id="oldToken"*/}
                            {/*formControlProps={{*/}
                                {/*fullWidth: true*/}
                            {/*}}*/}
                            {/*inputProps={*/}
                                {/*{*/}
                                    {/*name:"oldToken",*/}
                                    {/*type:"number",*/}
                                    {/*onChange:handleChange,*/}
                                {/*}}*/}
                        {/*/>*/}
                        {/*/!* </Paper> *!/*/}
                    {/*</Grid>*/}
                    <Grid item md={12} sm={12}>
                        {/* <Paper className={classes.paper}> */}
                        <CustomInput
                            className={classes.input}
                            required
                            labelText="Token"
                            id="newToken"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={
                                {
                                    name:"newToken",
                                    type:"number",
                                    onChange:handleChange,
                                }}
                        />
                        {error && <span style={{color:'red'}}>{formError}</span>}
                        {/* </Paper> */}
                    </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="danger">
                        Cancel
                    </Button>
                    <Button disabled={disabled} onClick={handleSubmit} color="primary" autoFocus>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};


export default withStyles(styles)(SettingsPanel);



// WEBPACK FOOTER //
// ./src/views/Settings/settingsPanel.js